import { Class } from "core/Abacus.Utilities";
import { SpinnerClass } from "core/classes/spinner.class";
import "libraries/Chained/jquery.chained";

class CurriculumExplorer extends Class {
  constructor(element, options) {
    super();
    this.element = $(element);
    this.setOptions(options);
    this.chainedSelects();
    this.setupEvents();
  }

  chainedSelects() {
    let self = this;
    const level = this.element.find("#levelTwo"),
      area = this.element.find("#levelOne"),
      curriculum = this.element.find("#levelThree");
    // chained selects
    $(level).chained(area);
    $(curriculum).chained(level);

    // enable / disable settings button when changes have been made
    $(curriculum).change(function(evt) {
      if (!this.selectedIndex) {
        self.element.find("[data-settings-done]").prop("disabled", true);
      } else {
        self.element.find("[data-settings-done]").prop("disabled", false);
      }
    });
  }

  setupEvents() {
    var self = this;

    // show settings panel
    this.element.on("click", "[data-settings-button]", function(evt) {
      evt.preventDefault();
      self.toggleSettings();
    });

    // close settings panel - close button
    this.element.on("click", "[data-settings-button-close]", function(evt) {
      evt.preventDefault();
      self.element.removeClass("settings-shown");
    });

    // collect and post updated settings
    this.element.on("click", "[data-settings-done]", function(evt) {
      self.postUpdatedSettings();
    });

    // category items and children
    this.element.on("click", "[data-explorer-item]", function(evt) {
      evt.preventDefault();
      self.makeRequestCategories(evt.target);
    });
  }

  toggleSettings() {
    this.element.toggleClass("settings-shown");
  }

  postUpdatedSettings() {
    let self = this;
    $(this.element)
      .find("form")
      .on("submit", function(evt) {
        evt.preventDefault();
        self.makeRequestSettings(this);
      });
  }

  // posts updated settings and returns new fragment of html
  // which replaces existing html.
  makeRequestSettings() {
    let self = this;
    let settingsForm = this.element.find(".curriculum-settings form"),
      data = settingsForm.serialize();
    $.ajax({
      url: "/categoryexplorer",
      method: "post",
      data,
      beforeSend: () => {
        $(settingsForm).addClass("ui-loading");
        self.spinner = new SpinnerClass(settingsForm, {
          spinnerOptions: {
            color: "black"
          }
        });
      },
      success: data => {
        $(self.element)
          .find("[data-content-replace]")
          .replaceWith(data);
        $(settingsForm).removeClass("ui-loading");
        self.spinner.spinner.stop();
        $(self.element).removeClass("settings-shown");
        self.chainedSelects();
        $(window).trigger("abacus:explorersettings:updated", [self.element]);
      }
    });
  }

  // make ajax request and pass along the `catID`. HTML is
  // returned and replaces existing widget.
  makeRequestCategories(element) {
    let self = this,
        widgetid = this.element.data("widgetid"),
      data = element.dataset.categoryId ? element.dataset.categoryId : "",
      items = this.element.find("[data-explorer-items]");
    $.ajax({
      url: "/categoryexplorer",
      method: "get",
      data: {
        catID: data,
          wid: widgetid
      },
      beforeSend: () => {
        $(items).addClass("ui-loading");
        self.spinner = new SpinnerClass(items, {
          spinnerOptions: {
            color: "black"
          }
        });
      },
      success: data => {
        $(self.element)
          .find("[data-content-replace]")
          .replaceWith(data);
        $(items).removeClass("ui-loading");
        self.spinner.spinner.stop();
        self.chainedSelects();
        $(window).trigger("abacus:categoryitems:updated", [items]);
      }
    });
  }
}

export { CurriculumExplorer };



// WEBPACK FOOTER //
// ./Javascript/core/classes/explorer/explorer.class.js